"use client";

import { Alert, BodyLong, Heading } from "@navikt/ds-react";

import { TrackedExternalLink } from "@/components/Link/TrackedExternalLink";

function ErrorMessage(): React.ReactElement {
  return (
    <Alert variant="error">
      <Heading size="medium" spacing level="1">
        Beklager, teknisk feil
      </Heading>
      <BodyLong>
        På grunn av feil i systemene våre kan du ikke registrere deg akkurat nå.
      </BodyLong>
      <BodyLong spacing>Vennligst prøv igjen litt senere.</BodyLong>
      <BodyLong>
        <TrackedExternalLink href="https://www.nav.no/no/nav-og-samfunn/kontakt-nav/teknisk-brukerstotte/kontakt-teknisk-brukerstotte-nav.no">
          Kontakt teknisk brukerstøtte dersom problemene vedvarer.
        </TrackedExternalLink>
      </BodyLong>
    </Alert>
  );
}

export default ErrorMessage;
